<template>
	<div class="account-info">
		<div class="header4 card case-unit" v-for="item in cases" :key="item.message">
			<a class="text-left" :href="`/case/${item.id}`">Case:&nbsp;{{ item.id }}</a>
			<span class="to-right">{{ item.createdOn | moment("MM/DD/YY") }}</span>
			<br />
			<span class="color-gray">{{ item.address }}</span>
			<span class="to-right">{{ item.statusText }}</span>
			<br />
			<span class="color-gray">{{ item.pin }}</span>
		</div>
	</div>
</template>

<script>
import api from "@/store/utils/api";
export default {
	name: "account-info",
	data() {
		return {
			cases: [],
		};
	},
	async mounted() {
		// debugger;
		this.cases = await api.get("/api/v1/orders/${this.$route.params.id}");
		console.log(this.cases);
	},
	mounted() {
		this.$store.dispatch("getCase", { id: this.id }).then((res) => {
			console.log("res", res);
			this.caseData = res;
		});
	},
	computed: {
		id() {
			return this.$route.params.id;
		},
		caseStatus() {
			return this.$store.getters.getCaseData.orderStatus;
		},
	},
};
</script>

<style scoped lang="scss">
.account-info {
	text-align: left;
	display: grid;
	grid-gap: 20px;
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--dar-gray);
	}
	.case-unit {
		padding: 10px 20px;
		// margin-bottom: 15px;
	}
	.header4 {
		color: var(--accent);
	}
	.text-left {
		color: var(--accent);
	}
	.to-right {
		float: right;
	}
	.color-gray {
		font-size: 0.8em;
		color: #c4c4c4;
	}
}
</style>
